.kh{white-space:nowrap;}